<template lang="pug">
  .gvl-error
     p Error Test Page

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class ErrorTest extends Vue {
  mounted () {
    const params = {
      type: 'test',
      field: 'err_id'
    }

    this.$axios.post('/error-test/', params)
      .then(() => {})
      .catch(() => {
        const testStr = 123
        console.log(testStr.trim())
      })

    const testObject = {}
    console.log(testObject.trim())
  }
}
</script>
